module.exports = __webpack_public_path__ + "static/media/home-banner-principal.6f376f74.png";